import { CreateForm } from "./create-form";

export const CreatePost = () => {
  return (
    <div className="postContainer">
      <CreateForm />
    </div>
  );
};
